import { notify } from "../../event-bus";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    messages: [],
    messagesExternal: []
  },
  getters: {
    messages: (state) => {
      return state.messages;
    },
    messagesExternal: (state) => { 
      return state.messagesExternal
    }
  },
  actions: {
    sendMessage({ commit }, payload) {
      if (payload.message == '') {
        return false;
      }
      return Vue.http
        .post(`${process.env.VUE_APP_BACKEND_APP}/api/games/${this.state.game.game.id}/users/${this.state.user.user.id}/message`, 
        payload, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Socket-Id": window.Echo.socketId(),
          },
        })
        .then(() => {
          payload.userId = this.state.user.user.id
          commit("addMessage", payload);
        })
        .catch((error) => {
          notify(error, "ERROR");
        });
    },
  },
  mutations: {
    addMessage(state, payload) {
      if (payload.message == '') {
        return false;
      }
      const player = this.state.game.players.find(player => player.id == payload.userId)
      const message = {
        name: player.name,
        message: payload.message
      }
      state.messages.push(message);
      if (state.messages.length > 15) {
        state.messages.shift();
      }
    },
    addMessageExternal(state, payload) {
      if (payload.message == '') {
        return false;
      }
      var user = {}
      if (payload.userId == 0) {
        user.name = 'admin'
      } else {
        user = this.state.user.users.data.find(user => user.id == payload.userId)
      }
      const message = {
        name: user.name,
        message: payload.message
      }
      const last = state.messagesExternal.slice(-1)[0]
      if (last && last.message == message.message && last.name == message.name) {
        return
      }
      state.messagesExternal.push(message);
      if (state.messagesExternal.length > 15) {
        state.messagesExternal.shift();
      }
    },
    resetChat(state) {
      state.messages = [];
      state.messagesExternal = [];
    }
  }
};
